'use strict';

angular.module('atex.art').factory('ArtConflictModal',
['$rootScope', '$q', '$modal',

  function($rootScope, $q, $modal) {
    return {
      create: function(props) {
        var modalScope = $rootScope.$new(true);

        _.extend(modalScope, props);
        _.extend(modalScope, atex.act.ViewUtils);

        modalScope.serverBusy = false;
        modalScope.clientBusy = false;
        modalScope.attribute = '';
        modalScope.changes = '';
        modalScope.hasContentConflicts = false;

        if (typeof modalScope.suppressCompare === 'undefined') {
          modalScope.suppressCompare = false;
        }

        if ( typeof modalScope.conflictList !== 'undefined' && typeof modalScope.conflictList.aspects !== 'undefined' )
        {
          var changes = '';

          _.each(modalScope.conflictList.aspects, function(aspectData, aspectName) {
            if (aspectName === 'contentData') {
              modalScope.hasContentConflicts = true;
            }
            var attributes = aspectData[0].split(',');
            _.each(attributes, function(attribute) {
              if (changes !== '') {
                changes += ', ';
              } else {
                modalScope.attribute = attribute;
              }
              changes += attribute.trim();
            });
          });

          modalScope.changes = changes;
        }

        var modal = $modal({
          show: true,
          scope: modalScope,

          template: 'templates/conflict-modal.html',
          modalClass: 'conflict-modal ng-cloak',
          backdrop: 'static',
          keyboard: false
        });

        var deferred = $q.defer();

        var destroyModal = function() {
          modal.then(function(modalEl) {
            modalEl.on('hidden.bs.modal', function() {
              modalScope.$destroy();
            });

            modalEl.modal('hide');
          });
        };

        modalScope.doChooseLocal = function() {
          modalScope.clientBusy = true;
          deferred.resolve({ resolution: 'local' });
        };

        modalScope.doChooseServer = function() {
          modalScope.serverBusy = true;
          deferred.resolve({ resolution: 'server' });
        };

        modalScope.doCompare = function() {
          deferred.resolve({ resolution: 'compare', attribute:modalScope.attribute });
        };

        modalScope.doIgnore = function() {
          destroyModal();
          deferred.resolve({ resolution: 'ignored' });
        };

        return {
          whenResolved: function() {
            return deferred.promise;
          },

          destroy: function() {
            return destroyModal();
          }
        };
      }
    };
  }
]);
